@if (contractsInLiquidation.length > 0) {
  <div class="disclaimer-container" data-cy="contract-liquidation-disclaimer">
    <div class="disclaimer-layout">
      @if (contractsInLiquidation.length === 1) {
        {{ 'disclaimer.liquidationSingle1' | translate }} {{ contractsInLiquidation[0].frameworkContractNumber }} {{ 'disclaimer.liquidationSingle2' | translate }}
      }
      @if (contractsInLiquidation.length === 2) {
        {{ 'disclaimer.liquidationBoth1' | translate }} {{ contractsInLiquidation[0].frameworkContractNumber }} {{ 'disclaimer.liquidationBoth2' | translate }} {{ contractsInLiquidation[1].frameworkContractNumber }} {{ 'disclaimer.liquidationBoth3' | translate }}
      }
    </div>
  </div>
}